// extracted by mini-css-extract-plugin
export default {"pluginContainer":"pluginContainer---MuGjm","delimiter":"delimiter---zb4fX"};